import apiClient from "lib/axios";
import type {
  Attestation,
  AttestationRequest,
  VerifyAttestationResponse,
  VerifyBlockedAccountResponse,
} from "types/attestation.types";

export const attestationsService = {
  getMyAttestations: async (): Promise<Attestation[]> => {
    const { data } = await apiClient.get<Attestation[]>(
      "/student/attestations",
    );
    return data;
  },

  getAttestation: async (id: number): Promise<Attestation> => {
    const { data } = await apiClient.get<Attestation>(
      `/student/attestations/${id}`,
    );
    return data;
  },

  requestAttestation: async (
    payload: AttestationRequest,
  ): Promise<Attestation> => {
    const { data } = await apiClient.post<Attestation>(
      "/student/attestations",
      payload,
    );
    return data;
  },

  downloadPDF: async (id: number): Promise<Blob> => {
    const { data } = await apiClient.get(`/student/attestations/${id}/pdf`, {
      responseType: "blob",
    });
    return data;
  },

  /**
   * Vérification publique d'une attestation par son numéro.
   * Endpoint : GET /api/verify/attestation/{number}
   * Aucun token requis — route publique.
   */
  verifyAttestation: async (
    code: string,
  ): Promise<VerifyAttestationResponse> => {
    const { data } = await apiClient.get<VerifyAttestationResponse>(
      `/verify/attestation/${encodeURIComponent(code.trim().toUpperCase())}`,
    );
    return data;
  },
  /**
   * Public verification of a Blocked Account document by its number.
   * Endpoint: GET /api/verify/blocked-account/{number}
   * No token required — public route.
   */
  verifyBlockedAccount: async (
    code: string,
  ): Promise<VerifyBlockedAccountResponse> => {
    const { data } = await apiClient.get<VerifyBlockedAccountResponse>(
      `/verify/blocked-account/${encodeURIComponent(code.trim().toUpperCase())}`,
    );
    return data;
  },
};
